import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20artistic%20abstract%20background%20with%20flowing%20warm%20gradients%2C%20soft%20crimson%20and%20gold%20brush%20strokes%2C%20elegant%20minimal%20composition%2C%20dreamy%20atmosphere%2C%20luxurious%20feel%2C%20clean%20modern%20design&width=1920&height=600&seq=cta-bg-comics&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
          准备好开始你的<span className="text-primary-600">韩漫之旅</span>了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
          加入数百万韩漫爱好者的行列，探索精彩纷呈的韩国漫画世界。<br className="hidden sm:block" />
          免费阅读、高清画质、每日更新，精彩不容错过！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/fantasy-adventure"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-full font-label text-sm font-medium transition-all cursor-pointer whitespace-nowrap text-center"
          >
            <i className="ri-play-circle-line mr-2"></i>立即开始阅读
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 border border-foreground-300 hover:border-primary-400 text-foreground-700 hover:text-primary-600 rounded-full font-label text-sm transition-all cursor-pointer whitespace-nowrap text-center"
          >
            <i className="ri-team-line mr-2"></i>了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}